module.exports = __webpack_public_path__ + "static/media/icon_cancel.1230429b.svg";